import { render } from "./sign-in-overlay.vue?vue&type=template&id=6e5644f5&scoped=true"
import script from "./sign-in-overlay.vue?vue&type=script&lang=js"
export * from "./sign-in-overlay.vue?vue&type=script&lang=js"

import "./sign-in-overlay.vue?vue&type=style&index=0&id=6e5644f5&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5644f5"]])

export default __exports__